import { supabase } from '../../../lib/supabase';

// Reference data comes from the site's own tables, so the movement tool always
// matches what Admin maintains under Warehouses and Item Catalog.

// Active warehouses, as the canonical names the import file expects.
export async function fetchWarehouses() {
  const { data, error } = await supabase
    .from('warehouses')
    .select('name, display_name, is_inactive')
    .order('name');
  if (error) throw error;
  return (data || [])
    .filter(w => !w.is_inactive && (w.name || '').trim())
    .map(w => w.name.trim());
}

// Whole item catalog, paged past PostgREST's ~1000-row cap.
export async function fetchProducts() {
  const all = [];
  for (let from = 0; ; from += 1000) {
    const { data, error } = await supabase
      .from('items')
      .select('item_number, description')
      .order('item_number')
      .range(from, from + 999);
    if (error) throw error;
    all.push(...(data || []));
    if (!data || data.length < 1000) break;
  }
  return all
    .filter(i => (i.item_number || '').trim())
    .map(i => ({ itemNumber: i.item_number.trim(), description: (i.description || '').trim() }));
}

// -- Shared account mappings ----------------------------------
// Shorthand -> warehouse lives in app_settings so every admin works from the
// same learned map instead of a per-browser copy. Writes are admin-only by RLS.
const MAPPINGS_KEY = 'movement_account_mappings';

export async function fetchMappings() {
  const { data, error } = await supabase
    .from('app_settings')
    .select('value')
    .eq('key', MAPPINGS_KEY)
    .maybeSingle();
  if (error) throw error;
  if (!data?.value) return {};
  try {
    const parsed = JSON.parse(data.value);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export async function saveMappings(mappings) {
  const { error } = await supabase
    .from('app_settings')
    .upsert(
      { key: MAPPINGS_KEY, value: JSON.stringify(mappings || {}), updated_at: new Date().toISOString() },
      // **This said `key` alone and the save could never succeed.** The table is
      // keyed on the site AND the key together, and Postgres rejects an upsert
      // naming columns it has no unique rule for. So the map appeared to work,
      // because a copy is kept in the browser, under a line saying "Shared with
      // every admin", and no colleague ever saw it.
      { onConflict: 'org_id,key' },
    );
  if (error) throw error;
}
